
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/basket",
      function () {
        return require("private-next-pages/basket.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/basket"])
      });
    }
  